import { ThemeProvider } from "@greco/components";
import LoadingOverlay from "components/LoadingOverlay";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import SplitPane, { Pane } from "split-pane-react";
import "split-pane-react/esm/themes/default.css";
import { useAppStore } from "store/AppStore";
import { useImportedInvoicesStoreState } from "store/ImportedInvoicesStore";
import {
  ExportExcel,
  ExportExcelHandle,
} from "./ImportedInvoiceEntriesGrid/ExportExcel";
import ImportedInvoiceEntryGrid from "./ImportedInvoiceEntriesGrid/ImportedInvoiceEntryGrid";
import ImportedInvoiceGrid from "./ImportedInvoicesGrid/ImportedInvoiceGrid";
import Navigation from "./Navigation";
import i18n from "i18n";

// Invoices imported from QTG (motor quoting tool of GrECo Latvia) and their member
// offers, matched to the installments of the payment plan; see
// ai_docs/features/imported-invoices.md.
const ImportedInvoices = () => {
  const [sizes, setSizes] = useState([100, "30%", "auto"]);
  const [{ appState }, { setAppStoreValue }] = useAppStore();
  const { t } = useTranslation();
  const refExcelExport = useRef<ExportExcelHandle>(null);

  const {
    importedInvoicesLoadStatus,
    importImportedInvoicesStatus,
    pullImportedInvoicesStatus,
    rematchImportedInvoicesStatus,
    deleteImportedInvoiceStatus,
  } = useImportedInvoicesStoreState();

  const isLoading =
    importedInvoicesLoadStatus === "loading" ||
    importImportedInvoicesStatus === "loading" ||
    pullImportedInvoicesStatus === "loading" ||
    rematchImportedInvoicesStatus === "loading" ||
    deleteImportedInvoiceStatus === "loading";

  useEffect(() => {
    setAppStoreValue(
      "headerTitle",
      t("pct.premiumCollectionTool.label") +
        " - " +
        t("pct.importedInvoices.label")
    );
  }, [i18n.language]);

  return (
    <>
      <ThemeProvider isDarkMode={appState.darkMode}>
        <Navigation refExcelExport={refExcelExport} />
      </ThemeProvider>

      <SplitPane
        split="horizontal"
        sizes={sizes}
        onChange={setSizes}
        resizerSize={5}
        sashRender={() => <></>}
        className="split-pane"
        style={{
          height: "calc(100% - 90px)",
        }}
      >
        <Pane minSize={"7%"} maxSize="93%">
          <ImportedInvoiceGrid />
        </Pane>
        <Pane minSize={"7%"} maxSize="93%">
          <ImportedInvoiceEntryGrid />
        </Pane>
      </SplitPane>

      <ExportExcel ref={refExcelExport} />

      {isLoading ? <LoadingOverlay /> : null}
    </>
  );
};

export default ImportedInvoices;
